<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5"
      @click="
        havePermissionGetOrUpdateQuizContent
          ? navigateToQuizDetailsPage(quiz._id)
          : null
      "
    >
      <v-row align="center">
        <v-col cols="12" sm="7">
          <div class="font-weight-light">
            <div class="d-flex flex-row justify-start flex-md-row align-center">
              <v-img
                :key="`quiz-card_${quiz._id}`"
                class="rounded-lg ms-3"
                height="60"
                max-width="90"
                :src="quiz.images ? getImage(quiz.images) : null"
                lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
                cover
              />

              <div
                class="ms-3 me-0 me-md-3 align-center"
                style="text-align: start"
              >
                <span
                  class="text-left subtitle-1 textLight--text text-ellipse-2"
                >
                  {{ getLocalisedValue(quiz.title) }}
                </span>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols>
          <span
            class="
              text-left
              subtitle-1
              textLight--text
              text-ellipse-2
              ps-3 ps-sm-0
            "
          >
            {{
              quiz.createdBy && quiz.createdBy.firstName
                ? quiz.createdBy.firstName
                : "-"
            }}

            <span v-if="quiz.createdBy && quiz.createdBy.lastName">
              {{ quiz.createdBy.lastName }}
            </span>
          </span>
        </v-col>

        <v-col cols="auto">
          <v-menu
            v-if="
              havePermissionEnableDisableQuizContent ||
              havePermissionDeleteQuizContent
            "
            class="flex-grow-1"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <template v-for="(item, i) in items">
                <v-list-item
                  v-if="
                    (item.value !== 'delete' &&
                      havePermissionEnableDisableQuizContent) ||
                    (item.value === 'delete' && havePermissionDeleteQuizContent)
                  "
                  :key="i"
                  class="hand-cursor"
                >
                  <v-list-item-title @click="updateOrDelete(item.value)">
                    <div class="d-flex justify-space-between">
                      <v-icon size="18" :color="item.iconColor" class="me-2">{{
                        item.icon
                      }}</v-icon>
                      {{ item.text }}
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { updateQuizContentStatus } from "../methods/updateQuizContentStatus";
import { deleteQuizContent } from "../methods/createOrUpdateOrDeleteQuizContent";
import { hasPermission } from "@/app/user-module/helpers/authHelper";

export default {
  name: "AvailableQuizCard",
  props: {
    quiz: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return [
        !this.quiz.isActive
          ? {
              icon: "mdi-check-circle-outline",
              iconColor: "green",
              text: "Enable",
              value: "enable",
            }
          : {
              icon: "mdi-cancel",
              iconColor: "",
              text: "Disable",
              value: "disable",
            },
        {
          icon: "mdi-trash-can-outline",
          iconColor: "red",
          text: "Delete",
          value: "delete",
        },
      ];
    },
    havePermissionGetOrUpdateQuizContent() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["GET_QUIZZES", "UPDATE_QUIZ"],
        requiredAll: false,
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionEnableDisableQuizContent() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["ENABLE_DISABLE_QUIZ"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
    havePermissionDeleteQuizContent() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["DELETE_QUIZ"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    navigateToQuizDetailsPage(quizId) {
      this.$router.push({
        name: "QuizDetails",
        params: { quizId },
      });
    },
    async updateOrDelete(val) {
      if (val) {
        if (val === "enable") {
          await updateQuizContentStatus({
            id: this.quiz._id,
            isActive: true,
          }).then(res => {
            this.$emit("quizzesListReRender");
          });
        } else if (val === "disable") {
          await updateQuizContentStatus({
            id: this.quiz._id,
            isActive: false,
          }).then(res => {
            this.$emit("quizzesListReRender");
          });
        } else if (val === "delete") {
          const msg =
            this.$i18n.locale === "ar"
              ? "سيتم حذف هذا الاختبار نهائيًا. هل أنت متأكد من الاستمرار؟"
              : "This quiz will be deleted permanently. Are you sure to continue?";

          this.$dialog
            .confirm(msg)
            .then(() => {
              deleteQuizContent(this.quiz._id).then(res => {
                this.$emit("quizzesListReRender");
              });
            })
            .catch(_ => {});
        }
      }
    },
  },
};
</script>
